import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import {ViewEncapsulation} from '@angular/core';
import swal from 'sweetalert2';
import { DecisionModel } from 'src/app/models/DecisionModel';
import { DecisionService } from 'src/app/services/DecisionService';
import { DecisionEntryComponent } from '../decision-entry/decision-entry.component';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { CompanyService } from 'src/app/services/CompanyService';


@Component({
  selector: 'app-decision-tab',
  templateUrl: './decision-tab.component.html',
  styleUrls: ['./decision-tab.component.css']
})
export class DecisionTabComponent implements OnInit {

   patientcode = '' ;
    Patientname = '';
    declocationtext = [];
    decdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
    declocation = '' ;
    decnotes = '' ;
    userid = '' ;
    username = '' ;
    wk_font = 2;
    wk_fontsize = '2ch';
    decisionList : DecisionModel[]=[];
    disablepharnacy =false;
    chkuser='';
    examlocationtext  = [];
    decnotestext ='';
    editorConfigNoToolbar = {
      editable: false,
      spellcheck: true,
      showToolbar: false,  // 🚫 This hides the toolbar
      height: 'auto',
      frameElement:false,
      minHeight: '0',
      width: '850px',
      placeholder: '',
      translate: 'no',
      defaultParagraphSeparator: '',
      defaultFontName: '',

      toolbarHiddenButtons: []
    };
    constructor(public decision: DecisionModel,
                  private dialogref: MatDialog,
                  public storage: LocalStorageService,
                  public companyService : CompanyService,
                  public decisionService :DecisionService,
                ) { }

    ngOnInit(): void {
      this.patientcode = this.storage.retrieve('stgPatientCode');
      this.Patientname = this.storage.retrieve('stgPatientName');
      this.decdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
      this.RetriveDecision();
      if(this.storage.retrieve('stgGroup') !='2' && this.storage.retrieve('stgGroup') !='8'){this.disablepharnacy = true}else{this.disablepharnacy = false}

    }
    RetriveDecision(){
      this.decisionList = [];
          this.decisionService.getDecisionPatient(this.patientcode).subscribe((data: DecisionModel[]) => {
                for (let i = 0; i < data.length; i++) {
                  this.decisionList[i] = data[i];
                  this.decisionList[i].decdate =formatDate(data[i].decdate, 'yyyy-MM-dd', 'en');

               this.companyService.getcompany(data[i].declocation).subscribe((data: CompanyModel) => {
                     this.declocationtext[i] = data.compName;
                 });
                }
              })
    }
    ZoomIn(){
      this.wk_font  = this.wk_font  + 0.5;
      this.wk_fontsize = this.wk_font + 'ch';
    }
    ZoomOut(){
      this.wk_font  = this.wk_font  - 0.5;
      this.wk_fontsize = this.wk_font + 'ch';
    }
    EditDecision(item: DecisionModel){
      this.chkuser = item.username;
      if( item.username == this.storage.retrieve('stgusername') || this.storage.retrieve('stgGroup') == '8')
        {

      this.storage.store('stgPatientCode',item.patientcode);
      this.storage.store('stgVisitDate',item.decdate)

      if(this.storage.retrieve('stgGroup') == '8'){
          this.storage.store('stgUserIdId',item.userid);
          this.storage.store('stgUsernamename',item.username);
      }
      // else
      // {
      //   this.storage.store('stgUserIdId','')
      //   this.storage.store('stgUsernamename','');
      // };

      const dialogRef = this.dialogref.open(DecisionEntryComponent,
        {
          data: {
            dataKey: this.decision,
            patintcode:  item.patientcode,
            docdate : item.decdate,
            decnotes : item.decnotes,
            userrecordid : item.userid,
            userid : this.storage.retrieve('stgUserId'),  
            userrecordname :this.storage.retrieve('stgUsernamename'),
            username :this.storage.retrieve('stgUsername')
            
          },
          width: '55vw',
          height: '70vw',
        });
      dialogRef.afterClosed().subscribe(result => {
      this. RetriveDecision();
      });

      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          this.RetriveDecision();
          dialogSubmitSubscription.unsubscribe();
        });
      }
      else
      {
        this.MesgWarrning();
      }
    }
   MesgWarrning(){

                swal({
                  title: 'Check User',
                  text:'Editing or deleting this medical record allowed only for: ' + this.chkuser,
                  type: 'warning',
                  showCancelButton: false,
                  confirmButtonText: 'OK',
                  //cancelButtonText: 'No, keep it',
                })
                ;

   }
    DeleteDecision(){

        this.decisionService.deleteDecision(this.storage.retrieve('stgVisitDate'),this.storage.retrieve('stgPatientCode'),this.userid).subscribe(
            (data: DecisionModel) => {
              this.RetriveDecision();
            }
          );
          this. RetriveDecision();
    }
    OpenDialog(){
      if(this.patientcode !='0000' && this.patientcode != '' ){

      var wk_Date =formatDate(new Date(), 'yyyy-MM-dd', 'en')

     this.storage.store('stgVisitDate',wk_Date )
      const dialogRef = this.dialogref.open(DecisionEntryComponent,
        {
          data: {
             dataKey: this.decision,
             patintcode:  this.patientcode,
             docdate : wk_Date,
             userrecordid :this.storage.retrieve('stgUserId'),
             userid : this.storage.retrieve('stgUserId'),  
            userrecordname :this.storage.retrieve('stgUsername'),
            username :this.storage.retrieve('stgUsername')
          },
          width: '55vw',
          height: '70vw',
        });
        dialogRef.afterClosed().subscribe(result => {
        this.RetriveDecision();
      });

      const dialogSubmitSubscription =
          dialogRef.componentInstance.submitClicked.subscribe(result => {
          this.RetriveDecision();
          dialogSubmitSubscription.unsubscribe();
        });

      }
    }
    MessegeDelete(item :DecisionModel){
      this.chkuser = item.username;
      if( item.username == this.storage.retrieve('stgusername') || this.storage.retrieve('stgGroup') == '8')
        {
      swal({
            title: 'Are you sure?',
            text: 'You will not be able to recover this record!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
          }).then(
            () => {
              this.storage.store('stgPatientCode',item.patientcode);
              this.storage.store('stgVisitDate',item.decdate);
              this.userid = item.userid;
              this.DeleteDecision();
              swal('Deleted!', 'Your record has been deleted.', 'success');
            },
            function (dismiss) {
              if (dismiss === 'cancel') {
                swal('Cancelled', 'Your record is safe :)', 'error');
              }
            }
          );
        }
        else
        {
          this.MesgWarrning();
        }
    }
  }
